import {AxiosResponse} from "axios";

import Api from "./api";
import {Habit, HabitInCreate, HabitInUpdate, HabitWithQuestions} from "../types";

interface GetAllHabitsResponse {
    habits: HabitWithQuestions[]
}

interface GetHabitWithQuestionsResponse {
    habit: HabitWithQuestions
}

export const getAllHabits = (): Promise<AxiosResponse<GetAllHabitsResponse>> => {
    // Get all visible habits
    return Api.get('/admin/habits/')
}


interface GetHabitResponse {
    habit: Habit
}


interface GetHabitWithQuestionsResponse {
    habitWithQuestions: HabitWithQuestions
}


export const getHabitById = (habitId: string): Promise<AxiosResponse<GetHabitWithQuestionsResponse>> => {
    return Api.get(`/admin/habits/${habitId}`)
}

export const createHabit = (habit: HabitInCreate): Promise<AxiosResponse<GetHabitWithQuestionsResponse>> => {
    const request = {
        habit: habit
    }
    return Api.post(`/admin/habits/`, request)
}

export const updateHabit = (habit: HabitInUpdate): Promise<AxiosResponse<GetHabitResponse>> => {
    const request = {
        habit: habit
    }
    return Api.put(`/admin/habits/`, request)
}

export const deleteHabit = (habitId: number): Promise<AxiosResponse> => {
    const request = {
        params: {habit_id: habitId},
    }
    return Api.delete(`/admin/habits/`, request)
}

interface DeviceModelsResponse {
    deviceModels: string[]
}

export const getAvailableDeviceModels = (): Promise<AxiosResponse<DeviceModelsResponse>> => {
    return Api.get('/admin/device-models')
}

export const getHabitDeviceModels = (habitId: string | number): Promise<AxiosResponse<DeviceModelsResponse>> => {
    return Api.get(`/admin/habits/${habitId}/device-models`)
}

export const setHabitDeviceModels = (habitId: string | number, deviceModels: string[]): Promise<AxiosResponse<DeviceModelsResponse>> => {
    return Api.put(`/admin/habits/${habitId}/device-models`, {deviceModels})
}

export default {
    getAllHabits, getHabitById, createHabit,
    getAvailableDeviceModels, getHabitDeviceModels, setHabitDeviceModels
}
